"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExpertTypeEnum = void 0;
var ExpertTypeEnum;
(function (ExpertTypeEnum) {
    ExpertTypeEnum["WEDDING_PLANNER"] = "wedding_planner";
    ExpertTypeEnum["PHOTOGRAPHER"] = "photographer";
    ExpertTypeEnum["VIDEOGRAPHER"] = "videographer";
    ExpertTypeEnum["CATERER"] = "caterer";
})(ExpertTypeEnum = exports.ExpertTypeEnum || (exports.ExpertTypeEnum = {}));
//# sourceMappingURL=experts.js.map